import {
    getRequestWithAdminAPI
  } from '../helpers/request';
  
  export const getCustomers = () => {
    const apiUrl = `customers`;
    return getRequestWithAdminAPI(apiUrl);
  };
  export const getPersons = (customerId) => {
    const apiUrl = `persons/?customerId=${customerId}`;
    return getRequestWithAdminAPI(apiUrl);
  };